
export default {
  name: 'AccountDeletionAgreement',
  layout: 'default',
  head() {
    return {
      title: 'XPPen Community Account Deletion Agreement',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'XPPen Community Account Deletion Agreement — prerequisites, consequences, cooling-off period and process for deleting your XPPen account.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'XPPen, Account Deletion, Cancel Account, Community',
        },
      ],
    }
  },
  mounted() {
    if (!process.client) return
    try {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      if (header) header.style.display = 'none'
      if (footer) footer.style.display = 'none'
    } catch (e) {}
  },
}
